import React, { useEffect, useState } from "react"
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
} from "reactstrap"

const cafeContext = require.context("../assets/galleryImages/cafe", true, /\.(png|jpe?g|webp)$/i)
const foodContext = require.context("../assets/galleryImages/food", true, /\.(png|jpe?g|webp)$/i)

const buildItems = (context, prefix) => context
  .keys()
  .sort((a, b) => a.localeCompare(b))
  .map((path, index) => ({
    id: `${prefix}-${path}`,
    src: context(path),
    altText: `Gallery image ${index + 1}`,
    caption: `Gallery image ${index + 1}`,
  }))

const items = [
  ...buildItems(cafeContext, "cafe"),
  ...buildItems(foodContext, "food"),
]

const CafeFoodCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [animating, setAnimating] = useState(false)

  const next = () => {
    if (animating || items.length === 0) return
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1
    setActiveIndex(nextIndex)
  }

  const previous = () => {
    if (animating || items.length === 0) return
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1
    setActiveIndex(nextIndex)
  }

  const goToIndex = (newIndex) => {
    if (animating) return
    setActiveIndex(newIndex)
  }

  useEffect(() => {
    if (items.length < 2) return undefined

    const rotationTimer = setTimeout(() => {
      setActiveIndex((currentIndex) => (currentIndex === items.length - 1 ? 0 : currentIndex + 1))
    }, 4500)

    return () => clearTimeout(rotationTimer)
  }, [activeIndex])

  if (items.length === 0) {
    return <div>No gallery images found.</div>
  }

  const slides = items.map((item) => (
    <CarouselItem
      onExiting={() => setAnimating(true)}
      onExited={() => setAnimating(false)}
      key={item.id}
    >
      <div style={{ textAlign: "center", backgroundColor: "#83868b" }}>
        <img src={item.src} alt={item.altText} style={{ maxHeight: 520, maxWidth: "100%", alignSelf: "center" }} />
      </div>
    </CarouselItem>
  ))

  return (
    <Carousel activeIndex={activeIndex} next={next} previous={previous}>
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel>
  )
}

export default CafeFoodCarousel
